<template>
    <div id="adminPage">
        <a href="/api/tcc-data.xlsx" id="download" class="button-submit">Export data</a>
        <h1>Events</h1>
        <div id="eventModal" class="admin-modal-wrapper" v-if="viewEventModal">
            <form id="newEvent" @submit="editEvent">
                <div class="close-modal" @click="closeModals">&times;</div>
                <label for="createEventName">Name: <input type="text" id="createEventName" v-model="eventFormData.name" required></label>
                <label for="createEventDesc">Description:</label>
                <textarea type="text" id="createEventDesc" v-model="eventFormData.desc"></textarea>
                <label for="createEventStartDate">Start Date: <input type="date" id="createEventStartDate" v-model="eventFormData.start_date" required></label>
                <label for="createEventEndDate">End Date: <input type="date" id="createEventEndDate" v-model="eventFormData.end_date" required></label>
                <label for="createEventSponsor">Sponsor:</label>
                <select name="createEventSponsor" id="createEventSponsor" v-model="eventFormData.sponsor_id">
                    <option value="">No sponsor</option>
                    <option v-for="sponsor in sponsors" :value="sponsor.id">{{sponsor.name}}</option>
                </select>
                <label for="createEventSponsorMessage">Sponsor Message:</label>
                <textarea name="createEventSponsorMessage" id="createEventSponsorMessage" v-model="eventFormData.sponsor_message"></textarea>
                <label for="createEventActive"><input type="checkbox" id="createEventActive" v-model="eventFormData.active"> Active</label>
                <button :class="{loading:loading}">Save</button>
            </form>
        </div>

        <button class="add" @click="openEditModal">Create New Event</button>

        <table id="eventList" class="admin-table">
            <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Sponsor</th>
                <th>Sponsor Message</th>
                <th>Active</th>
                <th> </th>
            </tr>
            <tr v-for="event in events">
                <td><div class="table-content-wrap">{{event.name}}</div></td>
                <td><div class="table-content-wrap">{{event.desc}}</div></td>
                <td><div class="table-content-wrap">{{event.start_date}}</div></td>
                <td><div class="table-content-wrap">{{event.end_date}}</div></td>
                <td><div class="table-content-wrap">{{event.sponsor ? event.sponsor.name : ""}}</div></td>
                <td><div class="table-content-wrap">{{event.sponsor ? event.sponsor.message : ""}}</div></td>
                <td><div class="table-content-wrap">{{event.active ? "Yes" : "No"}}</div></td>
                <td class="edit-button" @click="openEditModal(event)">Edit</td>
            </tr>
        </table>

        <h1>Sponsors</h1>
        <button class="add" @click="openSponsorModal">Create New Sponsor</button>
        <table id="sponsorList" class="admin-table">
            <tr>
                <th>Name</th>
                <th>Website</th>
                <th>Logo</th>
                <th> </th>
            </tr>
            <tr v-for="sponsor in sponsors">
                <td>
                    <div class="table-content-wrap">{{sponsor.name}}</div>
                </td>
<!--                <td>-->
<!--                    <div class="table-content-wrap">{{sponsor.desc}}</div>-->
<!--                </td>-->
                <td>
                    <div class="table-content-wrap sponsor-website"><a :href="sponsor.website">{{sponsor.website}}</a></div>
                </td>
                <td><img class="spons-logo" :src="sponsor.logo" v-if="sponsor.logo"><span v-if="!sponsor.logo">None</span></td>
                <td @click="openSponsorModal(sponsor)" class="edit-button">Edit</td>
            </tr>
        </table>
        <div id="sponsorModal" class="admin-modal-wrapper" v-if="viewSponsorModal">
            <form id="newSponsor" @submit="editSponsor">
                <div class="close-modal" @click="closeModals">&times;</div>
                <label for="createSponsorName">Name: <input type="text" id="createSponsorName" v-model="sponsorFormData.name" required></label>
<!--                <label for="createSponsorDesc">Description:</label>-->
<!--                <textarea type="text" id="createSponsorDesc" v-model="sponsorFormData.desc" required></textarea>-->
                <label for="sponsorImage">Sponsor Logo</label>
                <div id="logo" v-if="sponsorFormData.logo">
                    <img :src="sponsorFormData.logo" class="spons-logo" :class="{'deleting': this.deleteSponsorLogo}">
                    <div id="deleteLogo"><input type="checkbox" v-model="deleteSponsorLogo"> Delete Logo</div>
                </div>
                <input v-if="!sponsorFormData.logo" type="file" id="sponsorImage" ref="sponsorLogoFile" accept="image/gif,image/jpeg,image/png" @change="sponsorLogoCallback">
                <p v-if="fileTypeWarning" id="fileTypeWarning">File must be .jpg, .gif, or .png</p>
                <label for="createSponsorWebsite">Website: <input type="url" id="createSponsorWebsite" v-model="sponsorFormData.website" @blur="formatWebsite"></label>
                <button :class="{loading:loading}">Save</button>
            </form>
        </div>

        <h1>Projects</h1>
        <div id="projectModal" class="admin-modal-wrapper" v-if="viewProjectModal">
            <form id="newProject" @submit="editProject">
                <div class="close-modal" @click="closeModals">&times;</div>
                <label for="createProjectName">Name: <input type="text" id="createProjectName" v-model="projectFormData.name" required></label>
                <label for="createProjectDesc">Description:</label>
                <textarea type="text" id="createProjectDesc" v-model="projectFormData.desc" required></textarea>
                <label for="createProjectAmount">Amount Per Unit: <input type="number" id="createProjectAmount" v-model="projectFormData.amount_per_unit" required></label>
                <label for="createProjectUnit">Unit Name: <input type="text" id="createProjectUnit" v-model="projectFormData.unit_name" required></label>
                <label for="createProjectActive"><input type="checkbox" id="createProjectActive" v-model="projectFormData.active"> Active</label>
                <button :class="{loading:loading}">Save</button>
            </form>
        </div>

        <button class="add" @click="openProjectModal">Create New Project</button>
        <table id="projectList" class="admin-table">
            <tr>
                <th>Name</th>
                <th>Description</th>
                <th>$ Per Unit</th>
                <th>Unit Name</th>
                <th>Active</th>
                <th></th>
            </tr>
            <tr v-for="project in projects">
                <td>{{project.name}}</td>
                <td>{{project.desc}}</td>
                <td>{{project.amount_per_unit}}</td>
                <td>{{project.unit_name}}</td>
                <td class="project-active">{{project.active ? "Yes" : "No"}}</td>
                <td @click="openProjectModal(project)" class="edit-button">Edit</td>
            </tr>
        </table>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        name: "Admin",
        data: function() {
            return {
                viewEventModal: false,
                viewSponsorModal: false,
                viewProjectModal: false,
                eventFormData: {},
                sponsorFormData: {},
                projectFormData: {},
                events: {},
                sponsors: {},
                projects: {},
                loading: false,
                sponsorLogoChanged: false, // If true, will edit logo on server upon form submission
                deleteSponsorLogo: false, // Used to determine if we will delete a logo or upload a new one
                fileTypeWarning: false // if true, displays a file type warning
            };
        },
        created() {
            this.setEventData();
            this.setSponsorData();
            this.setProjectData();
            this.fetchData();
        },
        methods: {
            async fetchData() {
                this.events = await axios.get(this.$store.getters["server"] + "/events")
                    .then((data) => {
                        console.log(data.data.events);
                        return data.data.events;
                    });
                this.sponsors = await axios.get(this.$store.getters["server"] + "/sponsors")
                    .then((data) => {
                        console.log(data.data.events);
                        return data.data.events;
                    });
                this.projects = await axios.get(this.$store.getters["server"] + "/projects")
                    .then((data) => {
                        console.log(data.data.projects);
                        return data.data.projects;
                    });
            },
            closeModals() {
                this.viewEventModal = false;
                this.viewSponsorModal = false;
                this.viewProjectModal = false;
                this.loading = false;
                this.$store.commit("modalOpen", false);
                this.fileTypeWarning = false;
            },
            editEvent(e) {
                e.preventDefault();
                console.log(this.eventFormData);
                if (this.eventFormData.sponsor_id === "") {
                    this.eventFormData.sponsor_id = undefined;
                    this.eventFormData.sponsor_message = undefined;
                }
                if (this.eventFormData.sponsor_message === "") {
                    this.eventFormData.sponsor_message = undefined;
                }
                this.loading = true;
                axios.post(this.$store.getters['server'] + "/edit-event", this.eventFormData)
                    .then((response) => {
                        console.log(response);
                        this.fetchData();
                        this.closeModals();
                    });
            },
            setEventData(data) {
                if (data) {
                    data.sponsor_id = data.sponsor ? data.sponsor.id : "";
                    data.sponsor_message = data.sponsor ? data.sponsor.message : "";
                }
                console.log(data);
                this.eventFormData = Object.assign({
                    name: "",
                    desc: "",
                    start_date: this.parseDate(new Date()),
                    end_date: this.parseDate(new Date()),
                    active: false,
                    sponsor_message: undefined,
                    sponsor_id: undefined
                }, data === undefined ? {} : data);
            },
            openEditModal(data) {
                this.setEventData(data);
                this.viewEventModal = true;
                this.$store.commit("modalOpen", true);
            },
            editSponsor(e) {
                e.preventDefault();
                console.log(this.sponsorFormData);
                this.loading = true;
                axios.post(this.$store.getters['server'] + "/edit-sponsor", this.sponsorFormData)
                    .then(async (response) => {
                        console.log(response);
                        if (this.sponsorLogoChanged) {
                            console.log(response);
                            let data = new FormData();
                            console.log(this.$refs.sponsorLogoFile.files[0]);
                            data.append("id", this.sponsorFormData.id === undefined ? response.data.object.id : this.sponsorFormData.id);
                            data.append("action", "upload");
                            data.append("logo", this.$refs.sponsorLogoFile.files[0]);
                            console.log(data);
                            await axios.post(this.$store.getters['server'] + "/sponsor-logo", data,
                                {
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                    }});
                        } else if (this.deleteSponsorLogo) {
                            let data = new FormData();
                            data.append("id", this.sponsorFormData.id === undefined ? response.data.object.id : this.sponsorFormData.id);
                            data.append("action", "delete");
                            console.log(data);
                            await axios.post(this.$store.getters['server'] + "/sponsor-logo", data,
                                {
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                    }});
                        }
                        this.fetchData();
                        this.closeModals();
                    });
            },
            editSponsorLogo(e) {
                e.preventDefault();
            },
            setSponsorData(data) {
                this.sponsorFormData = Object.assign({
                    name: "",
                    desc: "",
                    website: ""
                }, data === undefined ? {} : data);
            },
            openSponsorModal(data) {
                this.setSponsorData(data);
                this.sponsorLogoChanged = false;
                this.deleteSponsorLogo = false;
                this.viewSponsorModal = true;
                this.$store.commit("modalOpen", true);
            },
            sponsorLogoCallback(e) {
                let acceptedFileTypes = ["image/jpeg", "image/gif", "image/png"];
                let fileType = e.target.files[0].type;
                console.log(e.target.files[0]);
                console.log(acceptedFileTypes.indexOf(fileType));
                if (acceptedFileTypes.indexOf(fileType) >= 0) {
                    console.log("Image changed!");
                    this.fileTypeWarning = false;
                    this.sponsorLogoChanged = true;
                } else {
                    this.fileTypeWarning = true;
                    e.target.value = '';
                    console.warn("File type " + fileType + " not accepted");
                }
            },
            editProject(e) {
                e.preventDefault();
                console.log(this.projectFormData);
                this.loading = true;
                axios.post(this.$store.getters['server'] + "/edit-project", this.projectFormData)
                    .then((response) => {
                        console.log(response);
                        this.fetchData();
                        this.closeModals();
                    });
            },
            setProjectData(data) {
                this.projectFormData = Object.assign({
                    name: "",
                    desc: "",
                    amount_per_unit: 0,
                    unit_name: "",
                    active: false
                }, data === undefined ? {} : data);
            },
            openProjectModal(data) {
                this.setProjectData(data);
                this.viewProjectModal = true;
                this.$store.commit("modalOpen", true);
            },
            parseDate(d) {
                let month = '' + (d.getMonth() + 1);
                let day = '' + d.getDate();

                if (month.length < 2) {
                    month = '0' + month;
                }
                if (day.length < 2) {
                    day = '0' + day;
                }

                return [d.getFullYear(), month, day].join('-');
            },
            formatWebsite(e) {
                e.preventDefault();
                console.log(e);
                if (!e.target.value.match(/^[a-zA-Z]+:\/\//)) {
                    this.sponsorFormData.website = 'http://' + this.sponsorFormData.website;
                }
            }
        }
    };
</script>

<style scoped lang="less">
    @import (reference) "../assets/variables";

    #download{
        padding: 0.75em 1em;
        position: absolute;
        left: 0;
        &:after{
            content: "\f56d";
            margin: 0 0 0 0.5em;
        }
    }
    .admin-modal-wrapper{
        position: fixed;
        height: 100vh;
        width: 100vw;
        top: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: rgba(0,0,0,0.8);
        form{
            position: relative;
            background: white;
            padding: 2rem;
            border-radius: 0.5rem;
            margin-bottom: 2rem;
            max-height: 100vh;
            overflow: auto;
        }
    }
    form{
        text-align: left;
    }
    label{
        display: block;
    }
    input[type=text], input[type=date], input[type=url], input[type=number], textarea{
        width: auto;
        border: 1px solid @text-color;
        font-size: 0.85rem;
        padding: 0.5em;
        margin: 0.5em 0;
        box-sizing: border-box;
        background: transparent;
    }
    textarea{
        min-width: 33em;
        min-height: 8em;
    }
    button.add{
        padding: 0.25em 0.75em;
        &:after{
            content: '\f055';
        }
    }
    .admin-table{
        margin-top: 1.5em;
        width: 100%;
        td{
            padding: 1em 0;
            border-bottom: 1px solid @light-gray;
        }
        tr:last-child td{
            border-bottom: 0;
        }
    }
    .table-content-wrap{
        max-height: 3em;
        overflow: hidden;
    }
    .edit-button{
        cursor: pointer;
    }
    .close-modal{
        position: absolute;
        font-size: 1.2em;
        font-weight: 700;
        top: 0.8em;
        right: 0.8em;
        cursor: pointer;
    }
    .sponsor-website{
        max-width: 20em;
        text-overflow: ellipsis;
    }
    .spons-logo{
        max-width: 175px;
        height: auto;
    }
    .deleting{
        opacity: 0.4;
    }
    #fileTypeWarning{
        color: @red;
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// src/components/Admin.vue